import styles from './BackgroundLayout.module.scss';

export const backgroundClassMap = {
	dark: styles.backgroundDark,
	light: styles.backgroundLight,
	none: '',
};

export const borderClassMap = {
	light: styles.borderLight,
	none: '',
};
